import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from 'antd';
import './Buttons.css';

/**
 * Button using
 *  - an icon as an IMAGE (use iconLocation param - only if special icon needed)
 *  OR
 *  - an ant design passed in icon (using icon param)
 */
const IconButton = ({ iconLocation = null, icon, ...rest }) => {

  return (
    <Button className={'dp-icon-button'} type='secondary' icon={iconLocation ? <img src={iconLocation} alt="" width="100%"/> : icon} {...rest}/>
  );
}

IconButton.propTypes = {
  iconLocation: PropTypes.string,
};

export default IconButton;